import { useCallback } from "react";
import { useMutation } from "urql";

import { DEFAULT_SNACKBAR_ERROR_MESSAGE } from "../constants/strings";
import { DeleteObjects } from "./queries.graphql";
import useShowSnackbar from "./useShowSnackbar";
import { useUrqlResponseHandler } from "./useUrqlResponseHandler";

export const useDeleteObjects = () => {
  const { showError } = useShowSnackbar();
  const { getResponseFromState } = useUrqlResponseHandler();
  const [result, deleteObjects] = useMutation(DeleteObjects);

  const delObjects = useCallback(
    async (objectIds: string[], onSuccess?: () => void) => {
      try {
        const result = await deleteObjects({
          input: {
            objectIds,
          },
        });

        const { error } = getResponseFromState({
          state: result,
          successMessage: `${objectIds.length > 1 ? "All files" : "File"} successfully deleted.`,
          errorMessage: DEFAULT_SNACKBAR_ERROR_MESSAGE,
        });

        if (!error) {
          onSuccess?.();
        }
      } catch (error) {
        console.error("Error deleting files", error);
        showError(DEFAULT_SNACKBAR_ERROR_MESSAGE);
      }
    },
    [deleteObjects, getResponseFromState, showError],
  );

  return { deleteObjects: delObjects, result };
};
